const ASSET_VENDORS_TABLE_READY = "assetVendors-table-ready"
const SEARCH_TEXT_STATE = "assetVendors-table-search-text-state"
const ROWS_PER_PAGE_STATE = "assetVendors-table-rows-per-page-state"
const PAGINATION_STATE = "assetVendors-table-pagination-state"

const ASSET_VENDOR_ID_FOR_ACTION = "assetVendors-table-assetVendor-id-for-action"

const ADD_EDIT_ASSET_VENDOR_READY = "add-edit-assetVendor-ready"


const PREVIOUS_ASSET_VENDOR_FILTER_STATUS = "previous-assetVendor-filter-status-action"

const PREVIOUS_ASSET_VENDOR_FILTER_GROUP_ID = "previous-assetVendor-filter-group-id-action"



const initialState = {
    isAssetVendorsTableReady: true,
    isAddEditAssetVendorReady:true,
    assetVendors: {},

    
    assetVendorSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterStatus : "",
    previousFilterGroupId : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ASSET_VENDORS_TABLE_READY:
            return Object.assign({}, state, { isAssetVendorsTableReady: action.payload })
        case ADD_EDIT_ASSET_VENDOR_READY:
            return Object.assign({}, state, { isAddEditAssetVendorReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ASSET_VENDOR_ID_FOR_ACTION:
            return Object.assign({}, state, {assetVendorSelectedId:action.payload})

        case PREVIOUS_ASSET_VENDOR_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        case PREVIOUS_ASSET_VENDOR_FILTER_GROUP_ID:
            return Object.assign({}, state, {previousFilterGroupId:action.payload})

        default:
        return state
    
    }

}

export function assetVendorsTableReady(data) {
    return {
        type: ASSET_VENDORS_TABLE_READY,
        payload: data
    }
}


export function addEditAssetVendorReady(data) {
    return {
        type: ADD_EDIT_ASSET_VENDOR_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function assetVendorIdForAction(assetVendorId){
    return{
        type:ASSET_VENDOR_ID_FOR_ACTION,
        payload:assetVendorId
    }
}

export function previousFilterStatus(filterVal){
    return{
        type:PREVIOUS_ASSET_VENDOR_FILTER_STATUS,
        payload:filterVal
    }
}


export function previousFilterGroupId(filterVal){
    return{
        type:PREVIOUS_ASSET_VENDOR_FILTER_GROUP_ID,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Asset Vendors/redux/assetVendors.js